// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu-search_menu__G9koC","active":"menu-search_active__m_0gW"};